import createReducer from './createReducer';
import {
  SET_CURRENT_MAP_POSITION,
 } from '../actions/map';

const initialState = {
  nearbyRegion: {},
};

const handlers = {};

handlers[SET_CURRENT_MAP_POSITION] = (state, { position }) => ({
  ...state,
  loading: false,
  position,
});

export default createReducer(handlers, initialState);



// WEBPACK FOOTER //
// ./src/reducers/map.js